import React, { useState, useEffect } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import { avatar14 } from "../_components/Imagepath";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import PropTypes from "prop-types";
import api from "../api/api"
import { useAuth } from "../context/AuthContext";
import ExportPDFBiodata from "./ExportPDFBiodata";
import { pdf } from '@react-pdf/renderer';
import Broadcast from "./Broadcast";
import BookEmployerBiodataShared from "../employers/BookEmployerBiodataShared";
import BiodataViewFields from "./components/BiodataViewFields";

import { useTranslation } from 'react-i18next';

const Profilebiodata = (prop) => {
  // const history = useHistory();
  const { history } = prop;
  const { user } = useAuth()
  const location = useLocation();
  const profile = location.state?.profile;
  const { t } = useTranslation();
  const [menu, setMenu] = useState(false);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  // Redirect back if there's no profile data
  if (!profile) {
    history.push("/");
    return <p>Redirecting...</p>;
  }

  const handleExportPDF = async (event) => {
    event.preventDefault();

   // if (!user.token) return

    let typeurl;

    if (user.type != 'agency' | profile.supplier) {
      typeurl = "/vendor-details";
    } else {
      typeurl = "/agency-details/";
    }

    const responseDetails = await api.get(typeurl, {
      params: {
        id: profile.supplier
      }
    });

    console.log("Response Details: ", profile);

    const body = {
      id: profile.id,
      is_supplier_biodata: profile.supplier ? true : false,
    };


    if (user.type != 'agency') {
      typeurl = "/export-pdf-biodata-supplier/"
    } else {
      typeurl = "/export-pdf-biodata-agency/"
    }

    const response = await api.post(typeurl, body);
    const data = response.data;

    const blob = await pdf(<ExportPDFBiodata data={data} supplier={responseDetails.data.details} />).toBlob();

    const url = window.URL.createObjectURL(blob);

    // window.open(url, '_blank') //For development, will open new tab as preview not download

    // Download biodata
    const link = document.createElement('a');
    link.href = url;
    
    link.setAttribute('download', `${responseDetails.data.details.company_name}-${profile.name}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  };

  return (
    <>
      <>
        <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
          <Header onMenuClick={() => toggleMobileMenu()} />
          <Sidebar />
          {/* Page Wrapper */}
          <div className="page-wrapper">
            <div className="content container-fluid">
              {/* Page Header */}
              <div className="page-header">
                <div className="content-page-header">
                  <h5>{t("Profile Biodata")}</h5>

                </div>
              </div>
              {/* /Page Header */}
              <div className="card ledger-list">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="ledger-info mb-4">
                    <div className="d-flex align-items-center">

                    </div>
                  </div>
                  <div className="list-btn">
                     <Link
                        className="btn border border-1  text-dark text-decoration-none m-2"
                        to=""
                        download=""
                        onClick={handleExportPDF}
                      >
                        <FeatherIcon icon="download" className="me-2" />
                        PDF
                      </Link>
                  </div>
                </div>
                {/* Table */}
                <FDWProfilePresentation profile={profile} />
                {/* /Table */}
              </div>
              <>
              </>
            </div>
          </div>

          {/* /Page Wrapper */}
        </div>

        {user.type == "supplier" && <Broadcast clickedBiodata={profile} />}
        {user.type == "agency" &&  <BookEmployerBiodataShared biodata={profile} isOpen={true} isAccepted={null} />}
      </>
    </>
  );
};
const FDWProfilePresentation = ({ profile }) => {
  const { user } = useAuth()
  if (!user) return null

  




  const data = profile;





  const [colorClassStatus, setColorClassStatus] = useState("")






  const [statusBiodata, setStatusBiodata] = useState(profile.status)
  const [statusBiodataLoader, setStatusBiodataLoader] = useState(false)
  const updateStatus = async (status) => {
    if (status == statusBiodata || statusBiodataLoader) return
    setStatusBiodataLoader(true)

    try {

      let response = await api.patch(`biodata-status/${user.type}/${profile.id}/`, { status: status });
      setStatusBiodata(status)
    } catch (error) {
      console.log(error)
    } finally {
      setStatusBiodataLoader(false)
    }
  }

  useEffect(() => {

    if (!statusBiodata) return;

    if (statusBiodata === "Published") {
      setColorClassStatus("bg-success-light");
    } else if (statusBiodata === "Draft") {
      setColorClassStatus("bg-info text-white");
    } else if (statusBiodata === "On-Hold") {
      setColorClassStatus("bg-gradient-light border round");
    } else if (statusBiodata === "Unavailable") {
      setColorClassStatus("bg-dark text-white");
    } else if (statusBiodata === "Removed") {
      setColorClassStatus("bg-danger text-white");
    } else {
      setColorClassStatus(""); // default/fallback
    }
  }, [statusBiodata]);

 

  let biodataOwner = false;

  if (user.type === 'agency') {
    const hasAgencyId = Object.prototype.hasOwnProperty.call(profile, 'agency') && profile.agency !== null;
    biodataOwner = hasAgencyId && "agency" === user.type

  } else if (user.type === 'supplier') {

    const hasSupplierId = Object.prototype.hasOwnProperty.call(profile, 'supplier') && profile.supplier !== null;

    biodataOwner = hasSupplierId && "supplier" === user.type
  }
  

  return (
    <div className="biodataprofile my-5">

<BiodataViewFields profile={profile} >
    
      {biodataOwner ?
      

      <div className="d-flex justify-content-between align-items-baseline mb-4 mx-2">

        {/** buttons */}
         <div>
          <div className="dropdown">
            <button
              className={`btn ${colorClassStatus} dropdown-toggle`}
              type="button"
              id="statusDropdown"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {statusBiodata}
              {statusBiodataLoader && <i className="fa-solid fa-spinner fa-spin" style={{ margin: "0 10px" }}></i>}
            </button>
            <ul className="dropdown-menu" aria-labelledby="statusDropdown">
              <li><button className="dropdown-item" onClick={() => updateStatus("Draft")}>Draft</button></li>
              <li><button className="dropdown-item" onClick={() => updateStatus("Published")}>Published</button></li>
              <li><button className="dropdown-item" onClick={() => updateStatus("On-Hold")}>On-Hold</button></li>
              <li><button className="dropdown-item" onClick={() => updateStatus("Unavailable")}>Unavailable</button></li>
              <li><button className="dropdown-item" onClick={() => updateStatus("Removed")}>Removed</button></li>
            </ul>
          </div>
        </div>

        <div>
          <ButtonsFunction biodataOwner={biodataOwner} profile={profile} />
        </div>
      </div>
      :
       <div  className="mt-4 float-end">
        {/** for sake of css flex end  i duplicate ButtonsFunction here too*/}
       <ButtonsFunction biodataOwner={biodataOwner} profile={profile} />
     </div>
     }



    </BiodataViewFields>
    </div>
  );
};


const ButtonsFunction = ({ profile }) => {
  const { user } = useAuth()
  const { t } = useTranslation();

  if (!user) return null
  let biodataOwner = false;

  if (user.type === 'agency') {
    const hasAgencyId = Object.prototype.hasOwnProperty.call(profile, 'agency') && profile.agency !== null;
    biodataOwner = hasAgencyId && "agency" === user.type

  } else if (user.type === 'supplier') {

    const hasSupplierId = Object.prototype.hasOwnProperty.call(profile, 'supplier') && profile.supplier !== null;

    biodataOwner = hasSupplierId && "supplier" === user.type
  }
  return (
    <div className="btn-group">
      {biodataOwner && (
        <Link
          to={{
            pathname: "/biodata-form/",
            state: { biodata: profile },
          }}
        >
          <button
            type="button"
            className="btn btn-success me-2"
          >
            <i className="fa-solid fa-pen me-2" />
            {t("Edit")}
          </button>
        </Link>
      )}

      {
        user.type === 'supplier' && (
          <button

        type="button"
        className="btn btn-primary rounded"
        data-bs-toggle="modal"
        data-bs-target="#broadcast_modal"
        disabled={profile.status != 'Published'}
      >
        <i className="fa-solid fa-share me-2" />
        {t("Broadcast")}
      </button>

        )
      }

      {
        user.type === 'agency' && profile.status == "Published" && (
          <button type="button"
            className="btn btn-greys mb-4 mx-2"
            data-bs-toggle="modal"
            data-bs-target="#book_biodata_dialog"
            disabled={!profile.booking_status && profile.is_have_booking}
          >
            {!profile.booking_status && profile.is_have_booking ?
              (
                <>
                  <i className="fe fe-pause-circle" /> {t("On-Hold")}
                </>
              ) : (
                <>
                  <i className="fe fe-mic me-2" /> {t("Book")}
                </>
              )
            }
          </button>
        )
      }
    </div>
  );
};


FDWProfilePresentation.propTypes = {
  profile: PropTypes.object.isRequired,
};
ButtonsFunction.propTypes = {
  profile: PropTypes.object.isRequired,
  biodataOwner: PropTypes.bool.isRequired,

};

export default Profilebiodata;
